import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@hqo/ui-atoms';
import { cn } from '@hqo/react-hooks';
import { TipProps } from './tip.types';

export const Tip = ({ content, children, className }: TipProps): JSX.Element => {
  const [open, setOpen] = React.useState(false);

  const handleClick = React.useCallback(() => {
    setOpen(!open);
  }, [open]);

  const handleMouseEnter = React.useCallback(() => {
    setOpen(true);
  }, []);

  const handleMouseLeave = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handleTouchStart = React.useCallback(() => {
    setOpen(!open);
  }, [open]);

  const handleKeyDown = React.useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setOpen(!open);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        setOpen(false);
      }
    },
    [open],
  );

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={open}>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={cn('cursor-pointer', className)}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleTouchStart}
            onKeyDown={handleKeyDown}
          >
            {children}
          </button>
        </TooltipTrigger>
        <TooltipContent
          className={cn(
            'max-w-[calc(100vw-2rem)] break-words mx-auto text-center',
            'px-3 py-2 min-w-0 w-auto',
            !content && 'hidden',
          )}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
